import { Provider } from 'react-redux';
import { BasicLayout } from 'components/layouts/BasicLayout';
import { HEADER_NAV_MENU } from '@doda/pc/src/constants/headerNavMenu';
import { InferGetServerSidePropsType } from 'next';
import { makeStore } from 'redux/store';
import { CareerRecommendJobListScreen } from './screens/CareerRecommendJobListScreen';
import { getServerSideProps } from './getServerSideProps';

/**
 * CareerRecommendJobListコンポーネント
 *
 * @param {InferGetServerSidePropsType<typeof getServerSideProps>} props - コンポーネントのプロパティ
 * @returns JSX要素
 */
const CareerRecommendJobList = (
  props: InferGetServerSidePropsType<typeof getServerSideProps>
) => {
  const {
    isShowAgentService,
    sideBarProps,
    modalMasterData,
    seoFooterLink,
    currentPage,
    leadSentence,
    initialState,
  } = props;

  const store = makeStore({ preloadedState: initialState });

  return (
    <Provider store={store}>
      <BasicLayout
        selectedNavItem={HEADER_NAV_MENU.SEARCH}
        leadSentence={leadSentence}
      >
        <CareerRecommendJobListScreen
          isShowAgentService={isShowAgentService}
          modalMasterData={modalMasterData}
          sideBarProps={sideBarProps}
          seoFooterLink={seoFooterLink}
          currentPage={currentPage}
        />
      </BasicLayout>
    </Provider>
  );
};

export { getServerSideProps };

export default CareerRecommendJobList;
